import React from 'react';
import TowerEquipmentListPageContainer from './TowerEquipmentListPageContainer';

export class TowerEquipmentListPage extends React.Component{
    
    render(){
      return (
        <TowerEquipmentListPageContainer {...this.props}/>
      )
    }
}

